import { DatatableCell, Skeleton } from '@monksflow/monks-ui';
import { TableSkeletonActionsCell, TableSkeletonRow } from '@/shared/ui/data-table';

/**
 * Loading placeholder row for {@link BriefTemplatesTable}, matching the
 * Projects/Folders skeleton treatment. Each cell's placeholder mirrors the
 * SHAPE of the real template row — leading icon badge + name, a rounded-full
 * status pill, a circular creator avatar — so the skeleton reads as a table
 * rather than a block of grey bars. Column order/widths match the header in
 * {@link BriefTemplatesTable}.
 *
 * The `<tr>` shell and its data-testid come from `TableSkeletonRow`; the
 * trailing 12-wide actions cell comes from `TableSkeletonActionsCell`.
 */
export const BriefTemplatesTableSkeletonRow = ({ showLevel = false }: { showLevel?: boolean }) => (
  <TableSkeletonRow testId="brief-templates-table-skeleton-row">
    {/* Name — icon badge + title */}
    <DatatableCell>
      <div className="flex items-center gap-3">
        <Skeleton className="size-10 rounded-lg" />
        <Skeleton className="h-4 w-40" />
      </div>
    </DatatableCell>

    {showLevel && (
      <DatatableCell>
        <Skeleton className="h-6 w-24 rounded-full" />
      </DatatableCell>
    )}

    {/* Status — rounded-full pill */}
    <DatatableCell>
      <Skeleton className="h-6 w-20 rounded-full" />
    </DatatableCell>

    {/* Created by — circular avatar + name */}
    <DatatableCell>
      <div className="flex items-center gap-2">
        <Skeleton className="size-6 rounded-full" />
        <Skeleton className="h-4 w-24" />
      </div>
    </DatatableCell>

    {/* Last modified */}
    <DatatableCell>
      <Skeleton className="h-4 w-24" />
    </DatatableCell>

    {/* Actions */}
    <TableSkeletonActionsCell />
  </TableSkeletonRow>
);

BriefTemplatesTableSkeletonRow.displayName = 'BriefTemplatesTableSkeletonRow';
